import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const offset = (el) => {
  const rect = el.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
    height: rect.height,
  };
};

const CustomInlineMenu = ({ items, scrollToTopOffset }) => {
  const [scrollPosition, setSrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setSrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!items) return null;

  const handleClick = (id) => {
    const element = document.getElementById(id);

    if (!element) return null;

    window.scrollTo({
      top: offset(element).top - scrollToTopOffset,
      behavior: 'smooth',
    });
  };

  const handleActiveState = (currentId, nextId, activeByDefault) => {
    const element = document.getElementById(currentId);
    const nextElement = document.getElementById(nextId);

    if (!element && activeByDefault) return true;

    if (!element) return false;

    if (!nextElement) {
      const offsetTop = offset(element).top - (scrollToTopOffset + 10);
      const offsetHeight = offset(element).height;

      return scrollPosition > offsetTop && scrollPosition < offsetTop + offsetHeight;
    }

    return (scrollPosition > offset(element).top - (scrollToTopOffset + 10) || activeByDefault) && scrollPosition < offset(nextElement).top - (scrollToTopOffset + 10);
  };

  return (
    <nav className="InlineMenu">
      <ul className="InlineMenu__nav">
        {items.map(({ menuItemName, elementId, activeByDefault }, index, elements) => (
          <li
            className={`InlineMenu__nav-item ${handleActiveState(elementId, (elements[index + 1] && elements[index + 1].elementId), activeByDefault) ? 'is-active' : ''}`}
            onClick={() => handleClick(elementId)}
            key={elementId}
          >
            {menuItemName || 'missing menuItemName'}
          </li>
        ))}
      </ul>
    </nav>
  );
};

CustomInlineMenu.defaultProps = {
  scrollToTopOffset: 0,
};

CustomInlineMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      menuItemName: PropTypes.string.isRequired,
      elementId: PropTypes.string.isRequired,
      activeByDefault: PropTypes.bool,
    }),
  ).isRequired,
  scrollToTopOffset: PropTypes.number,
};

export default CustomInlineMenu;
